interface PartitionParams {
  appName: string;
  sessionId: string;
  batchId: string;
  date?: Date;
}

// Athena Hive partition discovery breaks on `/`, spaces, and `=` in partition values.
// Reject early so a misconfigured consumer gets a clear error instead of a 6-month-
// later "why does Athena ignore half my data" investigation.
export const SAFE_APP_NAME = /^[a-zA-Z0-9._-]+$/;

export const buildS3Key = ({
  appName,
  sessionId,
  batchId,
  date = new Date(),
}: PartitionParams): string => {
  if (!SAFE_APP_NAME.test(appName)) {
    throw new Error(
      `[ecs-telemetry] invalid appName "${appName}" — must match ${SAFE_APP_NAME}`,
    );
  }
  const pad = (n: number): string => String(n).padStart(2, '0');
  const YYYY = date.getUTCFullYear();
  const MM = pad(date.getUTCMonth() + 1);
  const DD = pad(date.getUTCDate());
  const HH = pad(date.getUTCHours());
  const epochMs = date.getTime();
  return `events/app=${appName}/year=${YYYY}/month=${MM}/day=${DD}/hour=${HH}/${epochMs}_${sessionId}_${batchId}.jsonl.gz`;
};
